import script from "./PositionSettingsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PositionSettingsForm.vue?vue&type=script&setup=true&lang=js"

import "./PositionSettingsForm.vue?vue&type=style&index=0&id=79a8089c&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79a8089c"]])

export default __exports__